import { Component, ElementRef, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { DataSource } from '@angular/cdk/collections';
import { Observable } from 'rxjs/Observable';
import { fuseAnimations } from '../../../core/animations';
import { MatPaginator, MatSort, MatSnackBar, MatDialog } from '@angular/material';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import 'rxjs/add/observable/merge';
import 'rxjs/add/operator/map';
import { ElasticSearchService } from '../../../core/services/elastic-search.service';
import { AngularFirestore } from 'angularfire2/firestore';
import { ApiService } from '../../../core/services/api.service';
import { Subscription } from 'rxjs/Subscription';
import { DialogComponent } from './dialog/dialog.component';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-users',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.scss'],
  animations: fuseAnimations,
  providers: [ElasticSearchService]
})
export class UsersComponent implements OnInit, OnDestroy {

  displayedColumns = ['name', 'phone', 'email', 'join', 'posts', 'lastPost', 'profile'];
  onProductsChanged: BehaviorSubject<any> = new BehaviorSubject({});
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild('filter') filter: ElementRef;
  @ViewChild(MatSort) sort: MatSort;
  number: any;
  allUser: any;
  users: Array<any>;
  dataSource: MyDataSource;
  sub = new Subscription();
  sub3 = new Subscription();
  allPosts = 0;
  dailyPosts = 0;
  searchUsers: any;
  input: any;
  dailyUser = 0;
  filteredItems: Array<any>;
  getUser = 50;
  isAllUser = false;
  isLoading = true;
  howDay: any;
  sub2 = new Subscription();

  constructor(
    public snackBar: MatSnackBar,
    private apiService: ApiService,
    private afs: AngularFirestore,
    private dialog: MatDialog,
    private elastic: ElasticSearchService) {


    this.apiService.sqlGet('corporate/totalPosts').toPromise().then(data => {
      this.allPosts = data[0].total;
    });
    this.apiService.sqlGet('corporate/totalUsers').toPromise().then(data => {
      this.allUser = data[0].total;
    });
    this.afs.collection('users', ref => ref.orderBy('joinDate', 'desc').limit(this.getUser)).snapshotChanges().pipe(map(action => {
      return action.map(userData => {
        return {
          ...userData.payload.doc.data(),
          id: userData.payload.doc.id
        }
      })
    })).subscribe(snap => {
      this.number = snap.length;
      this.users = snap;
      this.onProductsChanged.next(this.users);
      this.dataSource = new MyDataSource(this.users, this.paginator, this.sort);
      this.isLoading = false;
    });

    // this.sub = this.afs.collection('users', ref => ref.orderBy('joinDate', 'desc').limit(this.getUser)).valueChanges().subscribe(snap => {
    //   this.number = snap.length;
    //   this.users = snap;
    //   this.onProductsChanged.next(this.users);
    //   this.dataSource = new MyDataSource(this.users, this.paginator, this.sort);
    //   this.isLoading = false;
    // });

  }

  getMoreUser() {

    this.sub.unsubscribe();
    this.isLoading = true;
    this.sub2 = this.afs.collection('users', ref => ref.orderBy('joinDate', 'desc').limit(this.getUser + 50)).snapshotChanges().pipe(map(actions => {
      return actions.map(userData => {
        return {
          ...userData.payload.doc.data(),
          id: userData.payload.doc.id

        }
      });

    })).subscribe(snap => {

      if (this.users.length !== snap.length) {
        this.getUser += 50;
      }

      this.number = snap.length;
      this.users = snap;

      console.log(this.users, 'user')
      this.onProductsChanged.next(this.users);
      this.dataSource = new MyDataSource(this.users, this.paginator, this.sort);
      this.isLoading = false;
    })
    // this.sub2 = this.afs.collection('users', ref => ref.orderBy('joinDate', 'desc').limit(this.getUser + 50)).valueChanges().subscribe(snap => {
    //   if (this.users.length !== snap.length) {
    //     this.getUser += 50;
    //   }

    //   this.number = snap.length;
    //   this.users = snap;
    //   console.log(this.users, 'user')
    //   this.onProductsChanged.next(this.users);
    //   this.dataSource = new MyDataSource(this.users, this.paginator, this.sort);
    //   this.isLoading = false;

    // })

  }

  getByDay(num) {

  }
  dialogSuggestions(key) {
    console.log(key)

    this.dialog.open(DialogComponent, {
      data: {
        key: key

      }
    });
  }

  changeTextCategory(string) {
    return string
      .replace(/ö/g, 'o')
      .replace(/Ö/g, 'o')
      .replace(/ç/g, 'c')
      .replace(/Ç/g, 'c')
      .replace(/ş/g, 's')
      .replace(/Ş/g, 's')
      .replace(/ı/g, 'i')
      .replace(/İ/g, 'i')
      .replace(/ğ/g, 'g')
      .replace(/Ğ/g, 'g')
      .replace(/ü/g, 'u')
      .replace(/Ü/g, 'u')
      .replace('&', 've')
      .replace(/,/g, '')
      .replace(/\./g, '_')
      .replace(/\'/g, '')
      .replace(/\s/g, '_').toLowerCase();
  }

  searchKeyUp(event) {
    // this.sub3.add(this.afs.collection('users').valueChanges().subscribe(data => {
    //   this.searchUsers = data;
    // }));

    const searchInput = this.input.replace(/\s/g, '').replace(/@/g, '').replace(/,/g, '').replace(/'/g, '').replace(/\./g, '').toLowerCase().trim();

    this.filteredItems = this.users.filter(
      item => {
        if (item.firstname !== undefined) {
          console.log(item.firstname);
          return this.changeTextCategory(item.firstname + ' ' + item.lastname).indexOf(this.changeTextCategory(this.input)) > -1
        }
      });
    this.dataSource = new MyDataSource(this.filteredItems, this.paginator, this.sort);
  }

  ngOnInit() {

  }



  ngOnDestroy(): void {
    if (this.sub2) {
      this.sub2.unsubscribe();
    }
    this.sub.unsubscribe();
    if (this.sub3) {
      this.sub3.unsubscribe();
    }
  }
}

export class MyDataSource extends DataSource<any> {
  constructor(
    private data: any,
    private _paginator: MatPaginator,
    private _sort: MatSort) {
    super();
  }
  _filterChange = new BehaviorSubject('');
  _filteredDataChange = new BehaviorSubject('');

  get filteredData(): any {
    return this._filteredDataChange.value;
  }

  set filteredData(value: any) {
    this._filteredDataChange.next(value);
  }

  get filter(): string {
    return this._filterChange.value;
  }

  set filter(filter: string) {
    this._filterChange.next(filter);
  }
  /** Connect function called by the table to retrieve one stream containing the data to render. */
  connect(): Observable<any[]> {
    const displayDataChanges = [
      this.data,
      this._paginator.page,
      this._filterChange,
      this._sort.sortChange
    ];
    return Observable.merge(...displayDataChanges).map(() => {
      let data = this.data.slice();

      this.filteredData = [...data];

      data = this.sortData(data);

      // Grab the page's slice of data.
      const startIndex = this._paginator.pageIndex * this._paginator.pageSize;
      return data.splice(startIndex, this._paginator.pageSize);
    });
  }

  sortData(data): any[] {
    if (!this._sort.active || this._sort.direction === '') {
      return data;
    }

    return data.sort((a, b) => {
      let propertyA: number | string = '';
      let propertyB: number | string = '';

      switch (this._sort.active) {
        case 'id':
          [propertyA, propertyB] = [a.id, b.id];
          break;
        case 'name':
          [propertyA, propertyB] = [a.name, b.name];
          break;
        case 'categories':
          [propertyA, propertyB] = [a.categories[0], b.categories[0]];
          break;
        case 'price':
          [propertyA, propertyB] = [a.priceTaxIncl, b.priceTaxIncl];
          break;
        case 'quantity':
          [propertyA, propertyB] = [a.quantity, b.quantity];
          break;
        case 'active':
          [propertyA, propertyB] = [a.active, b.active];
          break;
      }

      const valueA = isNaN(+propertyA) ? propertyA : +propertyA;
      const valueB = isNaN(+propertyB) ? propertyB : +propertyB;

      return (valueA < valueB ? -1 : 1) * (this._sort.direction === 'asc' ? 1 : -1);
    });
  }

  disconnect() { }

}


// WEBPACK FOOTER //
// C:/Users/Lenovo/Desktop/bigadviceadminSkeleton/src/app/main/content/users/users.component.ts